import React from "react";
import Header from "../../components/Header";
import AccountSettings from "../../components/AccountSettings";
import PaymentCard from "../../components/PaymentCard";
import Banner from "../../components/Banner";
import { PAYMENTS } from "../../constants/settingsStrings.js";
import Topbar from "../../components/Topbar";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import Bottombar from "../../components/Bottombar";

function SubcriptionAndPaymentScreen() {
  const cardData = [
    {
      id: 1,
      color: "#181059",
      text1: "Premium",
      text2: "Annual",
    },
    {
      id: 2,
      color: "#BE2117",
      text1: "Pro",
      text2: "Try 1 month",
    },
    {
      id: 3,
      color: "#181059",
      text1: "Base",
      text2: "Quarterly",
    },
  ];

  return (
    <div className="overflow-hidden dark:bg-black dark:text-black min-h-screen w-full">
      <Topbar />
      <Link to="/settings">
        <ArrowLeftIcon
          color="#545454"
          className="ml-4 w-5 h-6 sm:hidden mt-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded p-1 transition-colors"
        />
      </Link>

      <div className="md:block hidden">
        <Header />
      </div>

      <div className="flex flex-col sm:flex-row bg-white dark:bg-black sm:items-start sm:space-x-6 lg:space-x-10 sm:px-4 lg:px-10 sm:mt-5 sm:justify-center">
        <div className="hidden md:block flex-shrink-0">
          <AccountSettings active={PAYMENTS} />
        </div>
        <div className="w-full sm:max-w-4xl lg:max-w-5xl mt-2 min-h-[70vh] rounded-[15px] sm:shadow-xl sm:bg-white sm:dark:bg-gray-900 p-4 sm:p-6">
          <div className=" sm:ml-0 ">
            <Banner />
          </div>
          <div className="sm:hidden flex justify-center items-center space-x-2 mt-6 mb-4">
            <div className="bg-[#0049F5] w-8 h-1.5 rounded-full"></div>
            <div className="bg-gray-400 w-1.5 h-1.5 rounded-full"></div>
            <div className="bg-gray-300 w-1.5 h-1.5 rounded-full"></div>
            <div className="bg-gray-300 w-1.5 h-1.5 rounded-full"></div>
          </div>

          <div className="text-center mt-[10px] grid place-content-center mr-6 text-gray-500">
            <p className="sm:text-[13px] text-[12px] mt-5 sm:mt-0">
              We have several powerful plans for you <br /> to enjoy more
              features. Everything you need.
            </p>
          </div>
          <div className="justify-center flex mx-4 py-3">
          <div className="text-white bg-[#0049F5] rounded-[24px]   w-full   justify-between font-bold font-sans p-5  items-center  sm:hidden flex ">
            <p>Pro</p>  
            <p>Try  1 Month</p>
          </div>
          </div>
          <div className="sm:hidden ml-[130px] flex items-center space-x-1 ">
            <div className="border bg-[#0049F5] w-[32px] h-[5px] rounded-[5px] "></div>
            <div className=" border rounded-full w-[5px] h-[5px] bg-[#6A6A6A]"></div>
            <div className=" border rounded-full w-[5px] h-[5px]  bg-[#D9D9D9]"></div>
            <div className=" border rounded-full w-[5px] h-[5px] bg-[#D9D9D9]"></div>
          </div>
          <div className="items-center justify-center flex m-3 px-[50px] sm:hidden">
            <input
              className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-[#BE2117] before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-[#BE2117] checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-[#BE2117] checked:after:bg-[#BE2117] checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-[#BE2117] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-[#BE2117] dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-[#BE2117] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
              type="radio"
              name="flexRadioDefault"
              id="radioDefault01"
            />
            <h3 className="text-[14px] text-[#BE2117] font-bold py-4">
              Free 3-day trial, then UGX500/month
            </h3>
          </div>

          <div className="md:block hidden ">
            <div className="flex justify-center mt-5 ">
              {cardData.map(({ id, color, text1, text2 }) => (
              <PaymentCard
                  key={id}
                  color={color}
                  text1={text1}
                  text2={text2}
                />
              ))}
            </div>
          </div>
          <div className=" justify-center flex">
            <div className="border w-[356px] h-[56px] sm:hidden bg-[#1B253C] rounded-[12px]   mt-6 grid place-content-center  ">
              <h4 className="text-white font-sans font-bold ">
                <span className="m-2 items-center">
                
                  <input
                    type="checkbox"
                    className="form-checkbox rounded-full border-2 h-5 w-5"
                  />
                </span>
                Free 7-day trial, 
                <span className="text-2xl font-sans">UGX300</span>
                /year
              </h4>
            </div>
          </div>

          <div className=" mt-7 flex ">
            <button className="bg-[#0049F5] justify-center  sm:mt-0  items-center mx-auto  sm:h-10 rounded-[27.34px] text-white font-bold sm:w-48 w-[315px] h-[56px]">
              <Link to="/settings/paymentmethod"> Continue </Link>
            </button>

            
          </div>
        </div>
       
        
      </div>
      <h3 className="dark:text-white absolute text-[12px] text-[#878787] font-[700] sm:mt-9  sm:left-[50%]  sm:bottom-10 left-32  mt-14">
          Terms and conditions
        </h3>
      <Bottombar activeBar={'settings'}/>
    </div>
  );
}

export default SubcriptionAndPaymentScreen;
